<div class="row">
  <div class="col-sm-6">
    <h3>Nutzerliste</h3>
  </div>
  <div class="col-sm-6">
    <h3>
      Material Gruppen sichtbar für Benutzer ohne Gruppen
      <button type="button" class="ev-button" [disabled]="currentUserLock" (click)="toggleVisibility()">
        <i class="fa fa-2x" style="font-size: revert;" [ngClass]="groupVisibilityClasses"></i>
      </button>
    </h3>
  </div>
</div>
<div class="row">
  <div class="col-lg-6">
    <form name="form" #changeForm="ngForm">
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Benutzername</th>
            <th>Nachname</th>
            <th>Vorname</th>
          </tr>
          <tr class="filterrow">
            <th><input class="form-control input-sm" name="name_user" [(ngModel)]="data['name_user']"/></th>
            <th><input class="form-control input-sm" name="name_last" [(ngModel)]="data['name_last']"/></th>
            <th><input class="form-control input-sm" name="name_first" [(ngModel)]="data['name_first']"/></th>
          </tr>
        </thead>

        <tbody>
          @for (user of list.objects; track user) {
            <tr class="click"
              [ngClass]="{'selected': user.id === currentUser?.id}"
              (click)="setCurrentUser(user)"
              >
              <td>
                {{user.name_user}}
              </td>
              <td>
                {{user.name_last}}
              </td>
              <td>
                {{user.name_first}}
              </td>
            </tr>
          }
        </tbody>
      </table>

      <ev-navigation [page]="list.page" [pages]="list.pages" [query]="query()" (goto)="goto($event)"></ev-navigation>
    </form>
  </div>

  @if (!!currentUser) {
    <div class="col-lg-6">
      <h3>
        Sichtbare Gruppen für Benutzer #{{currentUser.id}} {{currentUser.name_user}} {{currentUserName}}
      </h3>
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Produktgruppe</th>
            <th>Gruppe</th>
            <th>Zugriff</th>
          </tr>
        </thead>
        <tbody>
          @for (productGroup of currentUserPermissions; track productGroup.productGroup.id) {
            <tr>
              <td>{{productGroup.productGroup.name}}</td>
              <td></td>
              <td>
                <button type="button" class="ev-button" [disabled]="currentUserLock" (click)="toggleProductGroup(productGroup)">
                  <i class="fa fa-2x" [ngClass]="productGroup.classes"></i>
                </button>
              </td>
            </tr>
            @for (group of productGroup.groups; track group.group.id) {
              <tr>
                <td></td>
                <td>{{group.group.group_id}} {{group.group.name}}</td>
                <td>
                  <button type="button" class="ev-button" [disabled]="currentUserLock" (click)="toggleGroup(group)">
                    <i class="fa fa-2x" [ngClass]="group.classes"></i>
                  </button>
                </td>
              </tr>
            }
          }
          <tr>
            <td>Sonstige</td>
            <td></td>
            <td></td>
          </tr>
          @for (group of currentUserPermissionUserGroups; track group.group.id) {
            <tr>
              <td></td>
              <td>{{group.group.group_id}} {{group.group.name}}</td>
              <td>
                <button type="button" class="ev-button" [disabled]="currentUserLock" (click)="toggleGroup(group)">
                  <i class="fa fa-2x" [ngClass]="group.classes"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
